/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Tape,
    TapeFromJSON,
    TapeFromJSONTyped,
    TapeToJSON,
    TapeFile,
    TapeFileFromJSON,
    TapeFileFromJSONTyped,
    TapeFileToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchEndpointResponse
 */
export interface SearchEndpointResponse {
    /**
     * 
     * @type {Array<Tape>}
     * @memberof SearchEndpointResponse
     */
    tapes: Array<Tape>;
    /**
     * 
     * @type {Array<TapeFile>}
     * @memberof SearchEndpointResponse
     */
    entries: Array<TapeFile>;
    /**
     * 
     * @type {number}
     * @memberof SearchEndpointResponse
     */
    total: number;
}

export function SearchEndpointResponseFromJSON(json: any): SearchEndpointResponse {
    return SearchEndpointResponseFromJSONTyped(json, false);
}

export function SearchEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tapes': ((json['tapes'] as Array<any>).map(TapeFromJSON)),
        'entries': ((json['entries'] as Array<any>).map(TapeFileFromJSON)),
        'total': json['total'],
    };
}

export function SearchEndpointResponseToJSON(value?: SearchEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tapes': ((value.tapes as Array<any>).map(TapeToJSON)),
        'entries': ((value.entries as Array<any>).map(TapeFileToJSON)),
        'total': value.total,
    };
}


